// extracted by mini-css-extract-plugin
export var container = "styles-module__container___GUHAy";
export var thumbnailContainer = "styles-module__thumbnailContainer___GVVYG";
export var textField = "styles-module__textField___XqYG4";
export var lastContainer = "styles-module__lastContainer___dsb6l";
export var toggleControls = "styles-module__toggleControls___gvvfv";
export var controlBtn = "styles-module__controlBtn___Kt7Q2";
export var buttonsContainer = "styles-module__buttonsContainer___sMNZ6";
export var removeBtn = "styles-module__removeBtn___Fws3S";
export var filesize = "styles-module__filesize___xL1aK";
export var errorIcon = "styles-module__errorIcon___mAiQU";
export var uploadFailed = "styles-module__uploadFailed___L1eqU";
export var errorContainer = "styles-module__errorContainer___J1rUc";
export var tryAgain = "styles-module__tryAgain___Yzd5J";
export var rotateButtons = "styles-module__rotateButtons___d_V73";